module.exports = __webpack_public_path__ + "img/lh2.30f18171.jpg";